<template>
    <div class="contents group">
        <div class="builder-type-preview">
            <div v-if="modelValue.show_alt && modelValue.alt_position">
                <table>
                    <tbody>
                        <tr v-if="modelValue.alt_position === 'top'">
                            <td>
                                <!-- eslint-disable -->
                                <div v-if="modelValue.show_alt" v-html="modelValue.alt" class="text-xs"></div>
                                <!-- eslint-enable -->
                            </td>
                        </tr>
                        <tr>
                            <td v-if="modelValue.alt_position === 'left'">
                                <!-- eslint-disable -->
                                <div v-if="modelValue.show_alt" v-html="modelValue.alt" class="text-xs"></div>
                                <!-- eslint-enable -->
                            </td>
                            <td>
                                <img
                                    v-if="modelValue.image"
                                    :src="getImageSrc(modelValue.image)"
                                    class="max-w-sm mx-auto"
                                />
                            </td>
                            <td v-if="modelValue.alt_position === 'right'">
                                <!-- eslint-disable -->
                                <div v-if="modelValue.show_alt" v-html="modelValue.alt" class="text-xs"></div>
                                <!-- eslint-enable -->
                            </td>
                        </tr>
                        <tr v-if="modelValue.alt_position === 'bottom'">
                            <td>
                                <!-- eslint-disable -->
                                <div v-if="modelValue.show_alt" v-html="modelValue.alt" class="text-xs"></div>
                                <!-- eslint-enable -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else-if="modelValue.image">
                <img v-if="modelValue.image" :src="getImageSrc(modelValue.image)" class="max-w-sm mx-auto" />
            </div>
            <div v-else>
                {{ lang('content::content.types.image.choose') }}
            </div>
        </div>
        <MountedTeleport v-if="openedIndex === levelIndex" to="#aside">
            <builder-sidebar-segment class="hidden">
                <builder-sidebar-headline>
                    {{ lang('fields::fields.segments.attributes') }}
                </builder-sidebar-headline>
                <builder-sidebar-content>
                    <div v-for="attribute in attributes" :key="attribute.slug">
                        <Field
                            v-model="modelValue[attribute.slug]"
                            :field="attribute"
                            :dusk="`form-content-${levelIndex}-${attribute.slug}`"
                            label-position="top"
                            size="xs"
                        />
                    </div>
                </builder-sidebar-content>
            </builder-sidebar-segment>
        </MountedTeleport>
    </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';
import BuilderSidebarHeadline from '@src/Content/Pages/Builder/Partials/SidebarHeadline.vue';
import BuilderSidebarSegment from '@src/Content/Pages/Builder/Partials/SidebarSegment.vue';
import BuilderSidebarContent from '@src/Content/Pages/Builder/Partials/SidebarContent.vue';

const modelValue = defineModel({
    type: [Object, undefined],
});

interface Props {
    attributes?: any[];
    levelIndex?: number;
    openedIndex?: number | null;
}

const props = withDefaults(defineProps<Props>(), {
    attributes: () => [],
    levelIndex: 0,
    openedIndex: null,
});

const { attributes, levelIndex, openedIndex } = toRefs(props);

const getImageSrc = (image: any): string => {
    if (!image) {
        return null;
    }

    if (image && image.url) {
        return image.url;
    }

    return URL.createObjectURL(image);
};
</script>
